import {USER_CONSTANTS} from '../actions/UserActions';
import { HYDRATE } from 'next-redux-wrapper';

const INITIAL_STATE = {
    error: null,
    info: null,
    baseInfo: null,
    plan: null,
    signup: null,
    verification: null,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        case HYDRATE:
            return {...state, ...action.payload.User};

        case USER_CONSTANTS.VERIFICATION_REQUEST:
            return {
                ...state,
                verification: action.payload,
                error: null,
            };

        case USER_CONSTANTS.SIGNUP:
            return {
                ...state,
                signup: action.payload,
                error: null,
            };

        case USER_CONSTANTS.SET_DATA:
            let {user_data, plan_data} = action.payload
            return {
                ...state,
                info: user_data,
                baseInfo: {
                    address: user_data.address,
                    email: user_data.email,
                    first_name: user_data.first_name,
                    last_name: user_data.last_name,
                    identity_id: user_data.identity_id,
                    landline_phone: user_data.landline_phone,
                    new_id_document: user_data.new_id_document,
                    old_id_document: user_data.old_id_document,
                    phone: user_data.phone,
                    state: user_data.state,
                    city: user_data.city
                },
                plan: plan_data,
            };

        case USER_CONSTANTS.SET_INFO:
            return {
                ...state,
                info: action.payload,
                baseInfo: {
                    address: action.payload.address,
                    email: action.payload.email,
                    first_name: action.payload.first_name,
                    last_name: action.payload.last_name,
                    identity_id: action.payload.identity_id,
                    landline_phone: action.payload.landline_phone,
                    new_id_document: action.payload.new_id_document,
                    old_id_document: action.payload.old_id_document,
                    phone: action.payload.phone,
                    state: action.payload.state,
                    city: action.payload.city
                }
            };

        case USER_CONSTANTS.SET_PLAN:
            return {
                ...state,
                plan: action.payload,
            };

        case USER_CONSTANTS.VERIFICATION_SUCCESS:
            return {
                ...state,
                verification: {
                    ...state.verification,
                    verified: true,
                }
            };

        case USER_CONSTANTS.VERIFICATION_FAILURE:
            return {
                ...state,
                verification: {
                    ...state.verification,
                    verified: false,
                }
            };

        case USER_CONSTANTS.FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        case USER_CONSTANTS.RESET:
            return {...INITIAL_STATE};

        case USER_CONSTANTS.CLEAR:
            return {
                ...state,
                error: null,
                verification: null
            };

        default:
            return state;
    }
}